import { render, staticRenderFns } from "./typeInjury.vue?vue&type=template&id=49b6b11c&"
import script from "./typeInjury.vue?vue&type=script&lang=js&"
export * from "./typeInjury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports